import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=131b7138&"
import script from "./NotificationSetting.vue?vue&type=script&lang=js&"
export * from "./NotificationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports